/* eslint-disable @typescript-eslint/no-explicit-any */
import { RichDescription } from '@rjsf/core';
import {
  DescriptionFieldProps,
  FormContextType,
  RJSFSchema,
  StrictRJSFSchema,
} from '@rjsf/utils';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../Popover';

/** The `DescriptionField` is the template to use to render the description of a field
 *
 * @param props - The `DescriptionFieldProps` for this component
 */
export function ShDescriptionFieldTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>({ description, registry, uiSchema }: DescriptionFieldProps<T, S, F>) {
  if (!description) {
    return null;
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="text-muted-foreground hover:text-foreground focus:ring-primary ml-1 inline-flex h-4 w-4 cursor-pointer items-center justify-center rounded-full"
          aria-label="Show description"
        >
          <Info className="h-3 w-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80" side="top">
        <RichDescription
          description={description}
          registry={registry}
          uiSchema={uiSchema}
        />
      </PopoverContent>
    </Popover>
  );
}
